import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Button, Image, Modal, Row, Col } from 'react-bootstrap';
// import NotVerified from "../../../../assets/images/not-verified-camp-master.svg";
import NotVerified from "../../assets/images/not-verified-camp-master.svg";
import { AiOutlineClose } from "react-icons/ai";

function CampUnverifiedModal({ showModal, setShowModal }) {
  const history = useHistory();
  const [show, setShow] = useState(false);

  const handleShowClose = (type) => {
    setShow(type);
    setShowModal(type);
  }

  useEffect(() => {
    setShow(showModal);
  }, [showModal]);

  return (
    <Modal centered show={show} onHide={() => handleShowClose(false)} className="guest-registration-camp guest-modal">
      <Modal.Header >
        <div className="close-button" onClick={() => handleShowClose(false)}>
          <AiOutlineClose className='close-guest-icon' />
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className='not-verified-image'>
          <Image src={NotVerified} alt="" />
        </div>
        <h3>You are not verified</h3>
        <p>A member of our team will be in touch to complete the verification process.</p>



        <div className="login-btn" onClick={() => handleShowClose(false)}>
          <button className="btn btn-outline login-btn camp-btn-room">Ok</button>
        </div>

      </Modal.Body>
    </Modal>
  );
}

export default CampUnverifiedModal;
